// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Customer } from './customer';
import { Product } from './product';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class CustomerProductPriceOverride extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get isActive() {
    return !this.deleted && (!this.endDate || this.endDate >= new Date());
  }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  created!: Date;
  createdBy?: string;
  customerId!: number;
  deleted?: Date;
  deletedBy?: string;
  endDate?: Date;
  price!: number;
  productId!: number;
  customer!: Customer;
  product!: Product;
}

